import React, { Component } from 'react';

class CheckBoxInput extends Component {
    constructor() {
        super();

        this.state = {
            deleteVisible: false
        };

        this.handleInput = this.handleInput.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    componentDidMount() {
        this.setState({
            value: this.props.formData.value
        });
    }

    handleInput(event) {
        this.props.onChange(this.props.formData.id, event.target.checked);
    }

    handleClick(event) {
        event.stopPropagation();
    }

    handleMouseOver() {
        this.setState({
            deleteVisible: true
        });
    }

    handleMouseLeave() {
        this.setState({
            deleteVisible: false
        });
    }

    render() {
        const { deleteVisible } = this.state;
        const { formData, editable, onDelete } = this.props;
        const { value } = formData;

        const style = {
            position: 'absolute',
            backgroundColor: 'black',
            padding: '1px',
            cursor: 'move',
            display: 'inline-block',
            ...this.props.style
        };

        if (editable) {
            return (
                <div
                    className={this.props.className}
                    style={style}
                    onMouseOver={this.handleMouseOver}
                    onMouseLeave={this.handleMouseLeave}
                    onMouseDown={this.props.onMouseDown}
                    onMouseUp={this.props.onMouseUp}
                    onTouchStart={this.props.onTouchStart}
                    onTouchEnd={this.props.onTouchEnd}
                    onClick={this.handleClick}
                >
                    <input
                        type='checkbox'
                        style={{ background: 'transparent' }}
                        checked={value}
                        onChange={this.handleInput}
                    />
                    {
                        (deleteVisible) ?
                            <button type='button' onMouseDown={() => onDelete(formData.id)}>X</button> :
                            null
                    }
                </div>
            );
        }
        else {
            return (
                <div style={{ position: 'absolute', top: this.props.position.y, left: this.props.position.x, padding: 20 }}>
                    <strong>{value ? 'x' : ''}</strong>
                </div>
            );
        }

        return (
            <div
                className={this.props.className}
                style={style}
                onMouseOver={this.handleMouseOver}
                onMouseLeave={this.handleMouseLeave}
                onMouseDown={this.props.onMouseDown}
                onMouseUp={this.props.onMouseUp}
                onTouchStart={this.props.onTouchStart}
                onTouchEnd={this.props.onTouchEnd}
                onClick={this.handleClick}
            >
                {
                    (editable) ?
                        <input
                            type='checkbox'
                            style={{ background: 'transparent' }}
                            checked={value}
                            onChange={this.handleInput}
                        /> :
                        <div><strong>{value ? 'x' : ''}</strong></div>
                }
                {
                    (deleteVisible) ?
                        <button type='button' onMouseDown={() => onDelete(formData.id)}>X</button> :
                        null
                }
            </div>
        );
    }

}

export default CheckBoxInput;



// WEBPACK FOOTER //
// ./src/components/document-editor/checkbox_input.jsx